// FETCH SURVEYS
export const FETCH_SURVEYS_REQUEST = 'FETCH_SURVEYS_REQUEST';
export const FETCH_SURVEYS_SUCCESS = 'FETCH_SURVEYS_SUCCESS';
export const FETCH_SURVEYS_FAIL = 'FETCH_SURVEYS_FAIL';
// FETCH SURVEY
export const FETCH_SURVEY_REQUEST = 'FETCH_SURVEY_REQUEST';
export const FETCH_SURVEY_SUCCESS = 'FETCH_SURVEY_SUCCESS';
export const FETCH_SURVEY_FAIL = 'FETCH_SURVEY_FAIL';
// FETCH SURVEY FORM
export const FETCH_SURVEY_FORM_REQUEST = 'FETCH_SURVEY_FORM_REQUEST';
export const FETCH_SURVEY_FORM_SUCCESS = 'FETCH_SURVEY_FORM_SUCCESS';
export const FETCH_SURVEY_FORM_FAIL = 'FETCH_SURVEY_FORM_FAIL';
// SUBMIT SURVEY FORM
export const SUBMIT_SURVEY_FORM_REQUEST = 'SUBMIT_SURVEY_FORM_REQUEST';
export const SUBMIT_SURVEY_FORM_SUCCESS = 'SUBMIT_SURVEY_FORM_SUCCESS';
export const SUBMIT_SURVEY_FORM_FAIL = 'SUBMIT_SURVEY_FORM_FAIL';
